import { render, staticRenderFns } from "./typeSolidManage.vue?vue&type=template&id=65fed6c8&scoped=true&"
import script from "./typeSolidManage.vue?vue&type=script&lang=js&"
export * from "./typeSolidManage.vue?vue&type=script&lang=js&"
import style0 from "./typeSolidManage.vue?vue&type=style&index=0&id=65fed6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fed6c8",
  null
  
)

export default component.exports